import React, { useState, useEffect } from 'react';

function Category({ category, level, onAddSubcategory, onDelete, }) {
  const [subcategories, setSubcategories] = useState([]);

  const handleAddSubcategory = () => {
    const name = prompt(`Enter subcategory name for ${category.name}:`);
    if (name) {
      const newSubcategory = { name, subcategories: [] };
      setSubcategories(prevSubcategories => [...prevSubcategories, newSubcategory]);
      onAddSubcategory(category, newSubcategory); // Pass parent category here
    }
  };

  const handleDelete = () => {
    console.log("delete",category)
    onDelete(category);
  };

  return (
    <div style={{ marginLeft: `${level * 20}px` }}>
      <div>
        {category.name}
        <button onClick={handleDelete}>Delete</button>
      </div>
      {level < 5 && (
        <button onClick={handleAddSubcategory}>Add Subcategory</button>
      )}
      {subcategories.map((subcategory, index) => (
        <Category
          key={index}
          category={subcategory}
          level={level + 1}
          onAddSubcategory={onAddSubcategory}
          onDelete={onDelete}
        />
      ))}
    </div>
  );
}

function NestedCategoryForm2() {
  const [categories, setCategories] = useState([]);

  const handleAddCategory = () => {
    const name = prompt('Enter category name:');
    if (name) {
      const newCategory = { name, subcategories: [] };
      setCategories([...categories, newCategory]);
    }
  };

  const handleAddSubcategory = (parentCategory, subcategory) => {
    const updatedCategories = updateCategories(categories, parentCategory, subcategory);
    setCategories(updatedCategories);
  };

  const handleDelete = (categoryToDelete) => {
    const updatedCategories = deleteCategory(categories, categoryToDelete);
    setCategories(updatedCategories);
  };

  const updateCategories = (categories, parentCategory, subcategoryToAdd) => {
    return categories.map((category) => {
      if (category.name === parentCategory.name) {
        return {
          ...category,
          subcategories: [...category.subcategories, subcategoryToAdd]
        };
      } else if (category.subcategories && category.subcategories.length > 0) {
        return {
          ...category,
          subcategories: updateCategories(category.subcategories, parentCategory, subcategoryToAdd)
        };
      }
      return category;
    });
  };

  const deleteCategory = (categories, categoryToDelete) => {
    console.log(categories, categoryToDelete)
    return categories.filter(category => {
      if (category.name === categoryToDelete.name) {
        return false; // Exclude the category to delete
      }
      if (category.subcategories && category.subcategories.length > 0) {
        // Recursively delete from subcategories
        category.subcategories = deleteCategory(category.subcategories, categoryToDelete);
      }
      return true;
    });
  };

  const logCompleteData = () => {
    console.log("categories", categories);
  };

  return (
    <div>
      <h1>Category Management</h1>
      <button onClick={handleAddCategory}>Add Category</button>
      <button onClick={logCompleteData}>Log Complete Data</button>
      {categories.map((category, index) => (
        <Category
          key={index}
          category={category}
          level={1}
          onAddSubcategory={handleAddSubcategory}
          onDelete={handleDelete}
        />
      ))}
    </div>
  );
}

export default NestedCategoryForm2;
